import { Status } from "@adgate/common/types/status.type";

export class ProductionRequestSample
{
    public static OBJECT_TYPE:number = 6;

    id!: number;
    requestId!: number;
    fileName!: string;
    status!: Status;

    constructor()
    {

    }
}